'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBhAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.69608e-05 0H27.9999C28.0005 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 9.66185e-06 20C9.66185e-06 13.3333 -0.000166285 6.66667 3.69608e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.9999 0H8.00001L10 1.33333L8.00001 2.66667L10 4L8.00001 5.33333L10 6.66667L8.00001 8L10 9.33333L8.00001 10.6667L10 12L8.00001 13.3333L10 14.6667L8.00001 16L10 17.3333L8.00001 18.6667L10 20H28L27.9999 0Z",
          fill: "#E7243B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.499939 0.5L0.499938 19.5L9.25187 19.5L10.0027 20H9.66185e-06L3.69608e-05 0H8.00001L8.75073 0.5L0.499939 0.5Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagBhAsset = forwardRef(FlagBhAsset);

export { VpFlagBhAsset as default };
